@switch (fieldValue()?.fieldType) {
<!-- ^ number -->
@case (formBuilderFieldTypes.Integer) {
<form-field
  [required]="fieldValue()?.isRequired"
  type="tel"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle"
  [minLength]="fieldValue()?.validation?.minLength"
  [maxLength]="fieldValue()?.validation?.maxLength"
  [min]="$any(fieldValue()?.validation?.minValue)"
  [max]="$any(fieldValue()?.validation?.maxValue)"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
}

<!-- ^ Decimal number -->
@case (formBuilderFieldTypes.DecimalNumber) {
<form-field
  [required]="fieldValue()?.isRequired"
  type="tel"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle"
  [minLength]="fieldValue()?.validation?.minLength"
  [maxLength]="fieldValue()?.validation?.maxLength"
  [min]="$any(fieldValue()?.validation?.minValue)"
  [max]="$any(fieldValue()?.validation?.maxValue)"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
}

<!-- ^ regex -->
@case (formBuilderFieldTypes.Regex) {
<form-field
  [required]="fieldValue()?.isRequired"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle"
  [minLength]="fieldValue()?.validation?.minLength"
  [maxLength]="fieldValue()?.validation?.maxLength"
  [min]="$any(fieldValue()?.validation?.minValue)"
  [max]="$any(fieldValue()?.validation?.maxValue)"
  [pattern]="fieldValue()?.validation?.regexValidation"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
}

<!-- ^ Boolean -->
@case (formBuilderFieldTypes.Boolean) {
<div class="w-fit">
  <mat-slide-toggle
    (change)="onChangeData(fieldValue()?.formBuilderFieldId, $event?.checked)"
  >
    {{ fieldValue()?.formBuilderFieldTitle | translate }}
  </mat-slide-toggle>

  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer tw-px-2"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</div>
}

<!-- ^ date -->
@case (formBuilderFieldTypes.Date) {
<datepicker
  [minType]="'custom'"
  [maxType]="'custom'"
  [min]="fieldValue()?.validation?.dateTimeMinValue"
  [max]="fieldValue()?.validation?.dateTimeMaxValue"
  [required]="fieldValue()?.isRequired"
  appearance="outline"
  [label]="fieldValue()?.formBuilderFieldTitle"
  (value)="onChangeData(fieldValue()?.formBuilderFieldId, $event, true)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</datepicker>
}

<!-- ^ time -->
@case (formBuilderFieldTypes.Time) {
<timepicker
  [required]="fieldValue()?.isRequired"
  appearance="outline"
  [label]="fieldValue()?.formBuilderFieldTitle"
  (value)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</timepicker>
}

<!-- ^SelectList  -->
@case (formBuilderFieldTypes.SelectList) {
<custom-select-search
  [required]="fieldValue()?.isRequired"
  [label]="fieldValue()?.formBuilderFieldTitle"
  [items]="$any(selectListOptions)"
  optionTitle="value"
  optionValue="value"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</custom-select-search>
}

<!-- ^ email -->
@case (formBuilderFieldTypes.Email) {
<form-field
  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
  [required]="fieldValue()?.isRequired"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle || 'common.email'"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
}

<!-- ^ mobileNumber -->
@case (formBuilderFieldTypes.MobileNumber) {
<form-field
  type="tel"
  [required]="fieldValue()?.isRequired"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle || 'common.mobileNumber'"
  [minLength]="10"
  [maxLength]="12"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
}

<!-- ^ file -->
@case (formBuilderFieldTypes.File) {
<file-uploader
  #fileUploader
  [label]="fieldValue()?.formBuilderFieldTitle"
  class="tw-w-[275px]"
  acceptFile=".jpeg,.png,.jpg,.pdf"
  [maxFileSize]="fieldValue()?.validation?.maxFileSizeByMegabyte"
  sizeType="mb"
  (valueChange)="getFile(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</file-uploader>

<app-show-images
  *ngIf="imageUrl"
  class="tw-mt-1"
  [src]="imageUrl"
></app-show-images>
}

<!-- ^ nationalCode -->
@case (formBuilderFieldTypes.NationalCode) {
<form-field
  [required]="fieldValue()?.isRequired"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle || 'common.nationalCode'"
  [isOnlyNumber]="true"
  [minLength]="10"
  [maxLength]="10"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
}

<!-- ^ bigText -->
@case (formBuilderFieldTypes.BigText) {
<form-textarea
  [required]="fieldValue()?.isRequired"
  [appearance]="'outline'"
  [label]="fieldValue()?.formBuilderFieldTitle"
  [minLength]="fieldValue()?.validation?.minLength"
  [maxLength]="fieldValue()?.validation?.maxLength"
  [rows]="5"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-textarea>
}

<!-- ^ default -->
@default {
<form-field
  [required]="fieldValue()?.isRequired"
  [appearance]="'outline'"
  [class]="'w-full'"
  [label]="fieldValue()?.formBuilderFieldTitle"
  [minLength]="fieldValue()?.validation?.minLength"
  [maxLength]="fieldValue()?.validation?.maxLength"
  [min]="$any(fieldValue()?.validation?.minValue)"
  [max]="$any(fieldValue()?.validation?.maxValue)"
  (valueChange)="onChangeData(fieldValue()?.formBuilderFieldId, $event)"
>
  <!-- field description -->
  <i
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    *ngIf="fieldValue()?.description"
    [matTooltip]="'common.description' | translate"
    prefix-content
    class="mdi mdi-help-circle-outline mdi-23px rtl:mr-2 ltr:ml-2 tw-cursor-pointer"
  ></i>

  <mat-menu #menu="matMenu">
    <span>{{ fieldValue()?.description }}</span>
  </mat-menu>
</form-field>
} }
